import type { ResultOf } from '@graphql-typed-document-node/core';
import { graphql } from 'src/gql';

export const ClientPortalAccountsListQuery = graphql(`
  query ClientPortalAccountsList($id: ID!, $householdId: ID) {
    portfolio(userId: $id, householdId: $householdId) {
      id
      accounts {
        id
        accountName
        accountNumber
        custody
        customName
        displayBalance {
          amount
        }
        firmName
        hiddenFromClient
        hiddenFromNetWorth
        lastUpdatedAt
        mask
        providerAccount {
          providerName
          source
        }
        providerAccountId
        providerLogoUrl
        subtype
        type
      }
      assets {
        id
        assetClass
        description
        hiddenFromClient
        hiddenFromNetWorth
        lastUpdatedAt
        netValue {
          amount
        }
      }
      liabilities {
        id
        currentBalance {
          amount
        }
        hiddenFromClient
        hiddenFromNetWorth
        lastUpdatedAt
        name
        providerName
        type
      }
    }
  }
`);

export type ClientPortalAccountsListResult = ResultOf<typeof ClientPortalAccountsListQuery>;

export type ClientPortalAccountsListPortfolio = ClientPortalAccountsListResult['portfolio'];
